import TradePermitModal from 'components/modals/documentModals/TradePermitModal';
import { useElectricalInspectionV4 } from 'hooks/useDocuments';
import { useElectricalInspection } from 'hooks/useElectricalInspection';
import { useGetQueryParam } from 'hooks/useModal';

export const ElectricalInspection = ({
  enableFetchByDocumentId = false,
}: {
  enableFetchByDocumentId?: boolean;
}) => {
  let result: any;

  if (enableFetchByDocumentId) {
    const documentId = useGetQueryParam('documentId');
    result = useElectricalInspectionV4(documentId || undefined);
  } else {
    const documentUuid = useGetQueryParam('electricalInspection');
    result = useElectricalInspection(documentUuid);
  }

  return (
    <TradePermitModal
      document={result.data}
      title="Electrical Permit"
      isLoading={result.isLoading}
    />
  );
};
